<style lang="less">
.app-layout-setting-vue {
  width: 300px;
  .h-panel-body {
    padding: 15px;
  }
  .alert-warning {
    border: 1px solid #ffe58f;
    background-color: #fffbe6;
    line-height: 1.5;
    font-size: 12px;
    color: rgba(0,0,0,.65);
    box-sizing: border-box;
    margin: 0;
    list-style: none;
    position: relative;
    padding: 10px 20px;
    border-radius: 4px;
    margin-top: 16px;
  }
  .setting-form {
    margin: 0 0 0 -15px;
    .h-form-item{
      margin-bottom: 10px;
    }
    .h-form-item-wrap {
      float: right;
    }
  }
}
</style>

<template>
  <div class="app-layout-setting-vue">
    <div class="h-modal-header">Configuração de layout do sistema</div>
    <div class="h-panel">
      <div class="h-panel-body">
        <Form class="setting-form" :labelWidth="120" labelPosition="left" readonly>
          <FormItem label="Estilo Sider">
            <SwitchList v-model="layoutConfig.siderTheme" small :datas="{'white': 'Claro', 'dark': 'Escuro'}"></SwitchList>
          </FormItem>
          <FormItem label="Fixo Header">
            <h-switch small v-model="layoutConfig.headerFixed"></h-switch>
          </FormItem>
          <FormItem label="Menu lateral fixo">
            <h-switch small v-model="layoutConfig.siderFixed"></h-switch>
          </FormItem>
          <FormItem label="Ativar várias guias">
            <h-switch small v-model="layoutConfig.showSystab"></h-switch>
          </FormItem>
          <p class="dark-color font13" style="padding: 10px 15px;">Depois de abrir várias guias, abra o keep-alive no aplicativo para habilitar o cache de páginas.</p>
        </Form>
        <Button block @click="copySetting">Cópia de configuração</Button>
        <!-- <p class="alert-warning">Todas as configurações estão no arquivo app-frame.vue e o layout é definido por meio do parâmetro layoutConfig.</p> -->
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    layoutConfig: Object
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    copySetting() {
      this.$Clipboard({ text: JSON.stringify(this.layoutConfig, null, 2), showSuccessTip: 'Cópia bem sucedida' });
    }
  }
};
</script>
